module.exports = __webpack_public_path__ + "img/sao.88f5d431.png";